import MapPlaceholder from "@/assets/images/map-placeholder.png";
import EventDetail from "@/domain/entities/emails/EventDetail";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardFooter, CardHeader } from "../../ui/card";
import EventDateTime from "./EventDateTime";
import EventLocation from "./EventLocation";

interface EventCardMailTileProps {
    event: EventDetail;
}

const EventCardMailTile = ({ event }: EventCardMailTileProps) => (
    <Card size="event" variant="event">
        <CardHeader className="mb-0 line-clamp-1 text-ellipsis font-body text-sm">
            {event.subject}
        </CardHeader>
        <CardContent variant="event">
            {event.startDateTime && event.endDateTime && (
                <EventDateTime
                    endDateTime={event.endDateTime}
                    startDateTime={event.startDateTime}
                />
            )}
            <div className={cn("z-layer h-14 overflow-hidden rounded-lg")}>
                {/* {<SmallMap location={event.location} />} */
                /* Google map component */}
                <img
                    alt="Map Placeholder"
                    className="h-18 w-full rounded-lg object-cover"
                    src={MapPlaceholder}
                />
            </div>
        </CardContent>
        <CardFooter className="text-xs">
            {event.location?.displayName && (
                <EventLocation
                    className="line-clamp-1 text-ellipsis"
                    displayName={event.location?.displayName}
                />
            )}
        </CardFooter>
    </Card>
);

export default EventCardMailTile;
